var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{ref:"hlsjs_video",attrs:{"controls":"true","id":"hlsjs"}})])}
var staticRenderFns = []

export { render, staticRenderFns }